import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query"
import { useEffect } from "react"
import { onAppActive } from "@/shared/lib/platform"
import { easyMatchKeys } from "../model/keys"
import { getEasyMatchStatus } from "./client"

export function easyMatchStatusQueryOptions(userId: number) {
	return queryOptions({
		queryKey: easyMatchKeys.status(userId),
		queryFn: () => getEasyMatchStatus(),
		staleTime: 30_000,
	})
}

export function useEasyMatchStatus(userId: number) {
	const queryClient = useQueryClient()
	const query = useQuery(easyMatchStatusQueryOptions(userId))

	useEffect(
		() =>
			onAppActive(() => {
				void queryClient.invalidateQueries({
					queryKey: easyMatchKeys.status(userId),
				})
			}),
		[queryClient, userId],
	)

	return query
}
